<template>
  <div>
    <FriendList :mode="mode"></FriendList>
  </div>
</template>

<script>
import FriendList from "../components/Main/FriendList.vue";
import store from "../vuex/store_friendList.js";
import { FriendListHandler } from "../handler/FriendListHandler";
import { MobileHomeHandler } from "@/handler/MobileHomeHandler.js";

export default {
  components: {
    FriendList
  },
  data() {
    return {
      mode: {
        type: "Mobile",
        token: this.$route.query.tct,
        staff: []
      }
    };
  },
  created() {
    document.title = "好友清單";
    var TutorChatTokenModel = MobileHomeHandler.GetTutorChatTokenModel(
      this.$route.query.tct
    );
    this.mode.staff = {
      userid: TutorChatTokenModel.Account,
      staffsn: TutorChatTokenModel.StaffSn,
      staffid: TutorChatTokenModel.StaffId
    };
    this.iniSignalr();

    // 取消斷線機制
    // //頁面閒置處理
    // var vm = this;
    // var maxTime = 90; // seconds
    // var time = maxTime;
    // $("body").on("keydown mousemove mousedown", function(e) {
    //   time = maxTime; // reset
    // });
    // var intervalId = setInterval(function() {
    //   time--;
    //   if (time <= 0) {
    //     ShowInvalidLoginMessage();
    //     clearInterval(intervalId);
    //   }
    // }, 1000);
    // function ShowInvalidLoginMessage() {
    //   vm.Disconnected();
    // }
  },
  mounted() {
    //window.addEventListener("focus", this.handleWinFocus);
  },
  methods: {
    iniSignalr: function() {
      this.signalrconn = $.hubConnection(this.$conf.MessageAPI + "/signalr");
      var proxy = this.signalrconn.createHubProxy("mainfriendListHub");

      //更新好友清單未讀數
      proxy.on("refreshFriendUnreadCount", data => {
        store.dispatch("RefreshUnreadCount", data);
      });
      //為了解決手機板從好友列表進入聊天室Vuex會遺失的問題，將值從sessionStorage中取出並設定好友清單。
      switch (sessionStorage.getItem("GroupSysType")) {
        case "all":
          //取得全部好友
          FriendListHandler.GetFriendList(this.mode.token);
          break;
        case "unreadlist":
          //取得未讀清單
          FriendListHandler.QueryUnreadList(this.mode.staff.staffid);
          break;
        case "unclass":
          //取得未分類清單
          FriendListHandler.QueryUnclassifiedList(this.mode.staff.staffid);
          break;
        case "salerecently":
          //取得最近聯繫業務
          FriendListHandler.QueryRecentlyStaffMainContact(
            this.mode.staff.staffid,
            0
          );
          break;
        case "custrecently":
          //取得最近聯繫客戶
          FriendListHandler.QueryRecentlyStaffMainContact(
            this.mode.staff.staffid,
            1
          );
          break;
        case "todaycontact":
          //今日應聯
          FriendListHandler.QueryTodayStaffMainContact(this.mode.staff.staffid);
          break;
        default:
          //取得群組好友
          FriendListHandler.GetGroupFriendList(
            sessionStorage.getItem("groupId"),
            this.mode.staff.staffid
          );
          break;
      }
    }

    // Disconnected() {
    //   this.signalrconn.stop();
    //   this.$alert("頁面閒置過久,確認後重新整理頁面", "提示", {
    //     confirmButtonText: "確認",
    //     type: "warning",
    //     center: true,
    //     callback: action => {
    //       location.reload();
    //     }
    //   });
    // },
    // handleWinFocus() {
    //   if (this.signalrconn.state === $.signalR.connectionState.disconnected) {
    //     this.Disconnected();
    //   }
    // }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileFriendListView.vue